import { TYPE_NUMBER } from './input-types';

export const id = 'totalQuantity';
export const apiKey = 'Quantity';
export const type = TYPE_NUMBER;

export const totalQuantity = {
  id,
  apiKey,
  type,
};
